import {useEffect} from "react";
import {ActionSheetPositionType} from "@MobileOverlays/types/ActionSheetPosition.type";

export default function useHandleActionSheetCloseOnPull(position: ActionSheetPositionType, backClick: () => void) {
    useEffect(() => {
        if (position === 0) {
            backClick()
        }
    }, [position])
}